@let scoreValue = score();
@let showLabelsSectionValue = showLabelsSection();
@let modeValue = mode();
@let minLabelValue = minLabel();
@let maxLabelValue = maxLabel();

<div class="rating-scale__options">
  @for (item of items(); track item.label) {
    @let score = item.score;

    <button
      type="button"
      class="rating-scale__option"
      [class.rating-scale__option--selected]="scoreValue === score"
      (click)="select(score)"
    >
      @if (item.icon) {
        <rt-icon
          [size]="'large'"
          [name]="item.icon"
          [colorToken]="scoreValue === score && item.color ? item.color : 'colorIconSubduedDefault'"
        />
      }

      <span class="rating-scale__label">{{ item.label }}</span>
    </button>
  }
</div>

@if (showLabelsSectionValue) {
  <div class="rating-scale__custom-labels">
    <div class="rating-scale__custom-label">
      @if (modeValue === RatingScaleMode.Edit) {
        <span class="rating-scale__connector"></span>
        <rt-input
          [formControl]="minLabelControl"
          [maxLength]="25"
          [placeholder]="
            'app.settings.candidate_evaluation.evaluation_scale_edit_dialog.add_label_placeholder'
              | translate
          "
        />
      } @else if (minLabelValue) {
        <span> {{ minLabelValue }} </span>
      }
    </div>

    <div class="rating-scale__custom-label rating-scale__custom-label--max">
      @if (modeValue === RatingScaleMode.Edit) {
        <span class="rating-scale__connector"></span>
        <rt-input
          [formControl]="maxLabelControl"
          [maxLength]="25"
          [placeholder]="
            'app.settings.candidate_evaluation.evaluation_scale_edit_dialog.add_label_placeholder'
              | translate
          "
        />
      } @else if (maxLabelValue) {
        <span> {{ maxLabelValue }} </span>
      }
    </div>
  </div>
}
